/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {DatagridColumnResizer} from './column-resizer';
import {STRICT_WIDTH_CLASS} from './constants';
import {DomAdapter} from './dom-adapter';
import {DatagridRenderOrganizer} from './render-organizer';
export class DatagridHeaderRenderer implements OnDestroy {
/**
 * @param {?} el
 * @param {?} renderer
 * @param {?} organizer
 * @param {?} domAdapter
 * @param {?} columnResizer
 */
constructor(private el: ElementRef,
private renderer: Renderer2,
private organizer: DatagridRenderOrganizer,
private domAdapter: DomAdapter,
private columnResizer: DatagridColumnResizer) {
        this.subscriptions.push(organizer.clearWidths.subscribe(() => this.clearWidth()));
        this.subscriptions.push(organizer.detectStrictWidths.subscribe(() => this.detectStrictWidth()));
    }
private subscriptions: Subscription[] = [];
/**
 * Indicates if the column has a strict width, so it doesn't shrink or expand based on the content.
 */
public strictWidth: number;
private widthSet: boolean = false;
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
/**
 * @return {?}
 */
private clearWidth() {
        // remove the width only if we set it, and it is not changed by dragging.
        if (this.widthSet && !this.columnResizer.columnResizeBy) {
            this.renderer.setStyle(this.el.nativeElement, "width", null);
        }
    }
/**
 * @return {?}
 */
private detectStrictWidth() {
        if (this.columnResizer.columnResizeBy) {
            this.strictWidth = this.columnResizer.columnRectWidth + this.columnResizer.columnResizeBy;
        } else {
            this.strictWidth = this.domAdapter.userDefinedWidth(this.el.nativeElement);
        }
    }
/**
 * @return {?}
 */
public computeWidth(): number {
        let /** @type {?} */ width: number = this.strictWidth;
        if (!width) {
            width = this.domAdapter.scrollWidth(this.el.nativeElement);
        }
        return width;
    }
/**
 * @param {?} width
 * @return {?}
 */
public setWidth(width: number) {
        if (this.strictWidth) {
            if (this.columnResizer.columnResizeBy) {
                this.renderer.setStyle(this.el.nativeElement, "width", width + "px");
                this.columnResizer.columnResizeBy = 0;
                this.widthSet = false;
            }
            this.renderer.addClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
            // We don't actually set the width if there already is a user-defined one, we just add the class
            return;
        }
        this.renderer.removeClass(this.el.nativeElement, STRICT_WIDTH_CLASS);
        this.renderer.setStyle(this.el.nativeElement, "width", width + "px");
        this.widthSet = true;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-dg-column"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: DatagridRenderOrganizer, },
{type: DomAdapter, },
{type: DatagridColumnResizer, },
];
}

function DatagridHeaderRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridHeaderRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridHeaderRenderer.ctorParameters;
/** @type {?} */
DatagridHeaderRenderer.prototype.subscriptions;
/**
 * Indicates if the column has a strict width, so it doesn't shrink or expand based on the content.
 * @type {?}
 */
DatagridHeaderRenderer.prototype.strictWidth;
/** @type {?} */
DatagridHeaderRenderer.prototype.widthSet;
/** @type {?} */
DatagridHeaderRenderer.prototype.el;
/** @type {?} */
DatagridHeaderRenderer.prototype.renderer;
/** @type {?} */
DatagridHeaderRenderer.prototype.organizer;
/** @type {?} */
DatagridHeaderRenderer.prototype.domAdapter;
/** @type {?} */
DatagridHeaderRenderer.prototype.columnResizer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
